import { removeHashFromUrl } from 'Utils/url';
import { openModalWhitepaperDownload } from 'Components/ModalWhitepaperDownload';
import { openModalAdditionalDocumentsDownload } from 'Components/ModalAdditionalDocumnetsDownload';

const WHITEPAPER_DOWNLOAD_HASH = 'whitepaper-download';
const ADDITIONAL_DOCUMENTS_DOWNLOAD_HASH = 'additional-documents-download';

export default {
  watch: {
    '$route.hash': {
      handler: '$_modalDocumentDownloadByHash_onHashChanged',
      immediate: true,
    },
  },
  methods: {
    $_modalDocumentDownloadByHash_getNormalizedHash(hash) {
      return hash.startsWith('#') ? hash.substr(1) : hash;
    },
    $_modalDocumentDownloadByHash_onHashChanged(hash) {
      const normHash = this.$_modalDocumentDownloadByHash_getNormalizedHash(hash);
      this.$_modalDocumentDownloadByHash_openModal(normHash);
    },
    async $_modalDocumentDownloadByHash_openModal(hash) {
      switch (hash) {
        case WHITEPAPER_DOWNLOAD_HASH: {
          await openModalWhitepaperDownload();
          break;
        }
        case ADDITIONAL_DOCUMENTS_DOWNLOAD_HASH: {
          await openModalAdditionalDocumentsDownload();
          break;
        }
        default: return;
      }
      this.$_modalDocumentDownloadByHash_onCloseModal();
    },
    $_modalDocumentDownloadByHash_onCloseModal() {
      removeHashFromUrl();
    },
  },
};
